import { hot } from 'react-hot-loader/root';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import ReaderHomePageContainer from './components/homePage/homePageContainer';
import InitContainer from './components/init/initContainer';
import ErrorBoundary from './components/errorBoundary/errorBoundary';
import { redirectToDownloadEndpoint } from './utils/errorHandlingUtils';

const PolyfillTest = () => { // TODO: remove this on completion of EPDF-2978
  if (window?.config?.browserInfo?.supportsPolyfillIo) {
    try {
      // eslint-disable-next-line no-new
      new Intl.DisplayNames(['il'], { type: 'region' });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Not filling');
    }
  }
  return null;
};

const App = ({ store }) => (
  <Provider store={store}>
    <div>
      <ErrorBoundary
        handleError={
          () => redirectToDownloadEndpoint(store.getState().pdfContent.pdfDownloadEndpoint)}
      >
        <InitContainer />
        <ReaderHomePageContainer />
      </ErrorBoundary>
    </div>
    <PolyfillTest />
  </Provider>
);

App.propTypes = {
  store: PropTypes.objectOf(
    PropTypes.func,
  ).isRequired,
};

const AppComponent = process.env.NODE_ENV !== 'production' ? hot(App) : App;

export default AppComponent;
